import $ from 'jquery';
import urls from '../urls';
import { searchConfig } from './config';

function formatSelection(result) {
	if (!result.id) {
		return result.text;
	}

	const container = $(`
        <span class="search__output-result js-result" />
    `);

	container.text(result.text);
	// container[0] means "get native JS object from jQuery object `container`"
	container[0].dataset.feature = JSON.stringify(result.feature);

	return container;
}

function formatProperties(name, properties) {
	const container = $(`
        <span>
            <span class="select_result-nazev" /><br>
            <span class="select_result-okres" />
        </span>
    `);

	container.find('.select_result-nazev').text(name);
	container.find('.select_result-okres').text("okres " + properties.NAZ_OKRES);

	if (properties.cja_id != "") {
		container.append('<br>');
		$('<span class="select_result-okres" />').appendTo(container).text(
			"ASJ: " + properties.cja_id + ", " + properties.cja_nazev
		);
	}

	return container;
}

function formatResult(result) {
	if (!result.id) {
		return result.text;
	}

	return formatProperties(result.text, result.feature.properties);
}

export const configSelect2 = (selectClassName) => {
	$(`.${selectClassName}`).select2({
		ajax: {
			url: urls.select2obceUrl,
			method: 'post',
		},
		language: searchConfig.language,
		width: '100%',
		placeholder: searchConfig.placeholder,
		//allowClear: true,
		templateResult: formatResult,
		templateSelection: formatSelection
	});
};
